import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography } from "@mui/material";
import { apiService } from "../../../api/apiService";
import { getStatusStyles } from '../../../components/Reusable/utils/getStatusStyles';
import RoutineStyle from "../../../components/Routine&Performance/RoutineUpload.module.css";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';



// Define interfaces for the data structure
interface ApiResponse {
  BSC_Mission: string;
  BSC_long_term_objective: string;
  created_at: any;
  status: string;
}

interface VisionStrategySectionUserProps {
  management: string;
  section_name: string;
}

const VisionStrategySectionUser: React.FC<VisionStrategySectionUserProps> = ({ management, section_name }) => {
  const { instance } = useMsal();
  const [data, setData] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const endpoint = `/strategy/fetch_existing_vision_n_strategy?management=${management}&section_name=${section_name}`;
      const result = await apiService(endpoint, 'GET', undefined, undefined, instance as PublicClientApplication);
      if (result && result.data) {
        setData(result.data);
      } else {
        setData(null); // Explicitly set data to null if no data is returned
      }

      console.log('Vision & Strategy Data:', result.data);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <>
      {data ? (
        // Vision & strategy data section
        <Box>

          <Typography sx={{ p: 1, pt: '0' }} className={RoutineStyle.routineHeading}>
                    Vision & strategy
                  </Typography>
                <Typography sx={{ p: 1, pb: '20px',pt:'0', fontSize: '14px' }}>
                  Question : BSC has a Mission statement that clearly defines its purpose and long-term objectives in line with GBS vision & goals
                </Typography>
        <Box
          sx={{
            padding: '20px',
            borderRadius: '11px',
            opacity: '0.9',
            background: '#FFF',
            boxShadow: '1px 1px 19.3px 0px rgba(0, 0, 0, 0.02)',
          }}
        >
         
          <Box sx={{ display: 'flex', gap: '400px' }}>
            <Box>
              <Typography variant="subtitle1" gutterBottom>BSC Mission</Typography>
              <Typography variant="h6">{data.BSC_Mission}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" gutterBottom>BSC Long term objective</Typography>
              <Typography variant="h6">{data.BSC_long_term_objective}</Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: '100px', padding: '20px 0px' }}>
            <Box>
              <Typography variant="subtitle1" gutterBottom>Create Date</Typography>
              <Typography variant="h6">{new Date(data.created_at).toLocaleDateString()}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" gutterBottom>Status</Typography>
              <Typography variant="h6" sx={{
                color: getStatusStyles(data?.status).color,
              }}>{data.status}</Typography>
            </Box>
          </Box>
        </Box>
        </Box>
      ) : (
        // Display "Data not found" message if data is null
        <Box
          sx={{
            padding: '20px',
            borderRadius: '11px',
            opacity: '0.9',
            background: '#FFF',
            boxShadow: '1px 1px 19.3px 0px rgba(0, 0, 0, 0.02)',
            textAlign: 'center',
          }}
        >
           <Typography sx={{ p: 1, pt: '0' }} className={RoutineStyle.routineHeading}>
            Vision & strategy
          </Typography>
          <Typography variant="h6">Data not found</Typography>
        </Box>
      )}
    </>
  );
};

export default VisionStrategySectionUser;